import Phaser from 'phaser';

import SystemUtils from '../../../common/utils/system';
import Scenes from '../scenes/main';


const phaserConfig = {
    width: 1280,
    height: 775,

    // レンダリングモード
    type: SystemUtils.isCT() ? Phaser.Canvas : Phaser.AUTO,

    // 物理エンジン設定
    physics: {
        default: 'arcade'
    },

    // FPS
    fps: {
        target: 30,
        forceSetTimeOut: false  // seetTimeout or requestAnimationFrame
    },

    // 背景を透明にする
    render: {
        transparent: true,
    },
    
    //ゲーム画面を描画するcanvasを書き出す先
    parent: 'js-scr-game',

    // ゲーム内で使用するシーン
    scene: Scenes,
}

export default phaserConfig;